module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABHNCSVQICAgIfAhkiAAAALZJREFUSEvtlUEKwkAMRZNQcWNnpW68hoeQLgR7ID2BnkS79BQ9i1I6u3aaBsH9JC5NdgP5fHjzINiddgyW4VRdzwFooqchHtGLs7E56mxUn0WXS8HL5VLAcrl0sH6VKx43B4BCVyrbE8f2dikBsNyrwziMCE0nxYZZYMurIMGlvjglKX68bfeYqBrDFpgt95ijF+d/tqPOZyWbLpcGl8ulofWnct1fvYrSd5moHsJaXkWjzjP2M+eu/Sc1qqTBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./styles/images/ms.png
// module id = 126
// module chunks = 0